// extracted by mini-css-extract-plugin
module.exports = {"flex":"insights_flex__RyxrK","item__button":"insights_item__button__d0ODz"};